/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useProjectUrl } from 'domain/shared/project';

const EditProjectButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useProjectUrl();

  return <EditButton {...props} path={getUpdateEntityUrl} />;
};

export default EditProjectButton;
